/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TutoraiDocumentsId200,
  GetApiV1TutoraiDocumentsId401,
  GetApiV1TutoraiDocumentsId404,
  GetApiV1TutoraiDocumentsId500,
  GetApiV1TutoraiDocumentsIdPathParams,
  GetApiV1TutoraiDocumentsIdQueryResponse,
} from "../../types/tutorAIDocumentosController/GetApiV1TutoraiDocumentsId.ts";
import { tutorAIDocumentSummaryViewModelSchema } from "../tutorAIDocumentSummaryViewModelSchema.ts";

export const getApiV1TutoraiDocumentsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1TutoraiDocumentsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TutoraiDocumentsId200Schema = z.lazy(
  () => tutorAIDocumentSummaryViewModelSchema,
) as unknown as ToZod<GetApiV1TutoraiDocumentsId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TutoraiDocumentsId401Schema =
  z.any() as unknown as ToZod<GetApiV1TutoraiDocumentsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1TutoraiDocumentsId404Schema =
  z.any() as unknown as ToZod<GetApiV1TutoraiDocumentsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TutoraiDocumentsId500Schema =
  z.any() as unknown as ToZod<GetApiV1TutoraiDocumentsId500>;

export const getApiV1TutoraiDocumentsIdQueryResponseSchema = z.lazy(
  () => getApiV1TutoraiDocumentsId200Schema,
) as unknown as ToZod<GetApiV1TutoraiDocumentsIdQueryResponse>;
